import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=532f7a53"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"
import style0 from "./styles/index.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports